module.exports = {"id":"202476","name":"Javi Espinosa","rating":"76","photo":"./data/images/photos/1/202476.png","club":{"name":"Grenade CF","logo":"./data/images/clubs/GrenadeCF.png"},"positions":["MOC","MD","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JaviEspinosa0.json
// module id = 1934
// module chunks = 0